import React from 'react';
import SectionTitle from './SectionTitle';
import IconList from '../../components/IconList';
import {
    LessonSection,
    MentalLinkIdentifier,
    WindowLayout,
} from '../../types';

type Props = {
    mental: MentalLinkIdentifier,
    lessonSection: LessonSection,
    infoDialogLayout: WindowLayout,
};

const LessonSectionView: React.FC<Props> = ({
    lessonSection,
}: Props) => (
    <div
        style={{ backgroundColor: lessonSection.layout.color.bgColor, color: lessonSection.layout.color.fontColor }}
    >
        <SectionTitle
            title={lessonSection.title}
            subTitle={lessonSection.subtitle}
        />
        <IconList
            items={lessonSection.lessonItems}
            baseCol={12}
        />
    </div>
);

export default LessonSectionView;
